<template>
<div style="height:100vh">
  <Pull-to
    class="board-scroll"
    @infinite-scroll="loadMore"
    :top-load-method="topLoadMore"
    :top-config="TOP_DEFAULT_CONFIG"
    :bottom-config="BOTTOM_DEFAULT_CONFIG"
    :is-top-bounce="false"
    :is-bottom-bounce="false"
    :is-scroll-sensitive="!isOver"
  >
    <div class="board" v-if="weekList">
      <div class="has-body" v-if="total>0 && isMember">
        <div class="heard">
          <p class="first">本周生日之星</p>
          <p class="second">{{total}}人过生日</p>
        </div>
        <div class="board-list">
          <ul>
            <li v-for="item in weekList" @click="toPersonInfo(item.id)">
              <div class="info">
                <div class="left">
                    <template v-if="item.useOpenData">
                        {{item.real_name | firstName}}
                    </template>
                    <template v-else>
                        {{item.real_name | toSubName}}
                    </template>
                </div>
                <div class="right">
                  <p class="name">
                    <Organization :name="item.real_name" type="userName" :openid="item.member_key_raw" :useOpenData="item.useOpenData" ></Organization>           
                  </p>
                  <p class="birthday">
                    {{toDateForYear(item.birthday,'month')}}月{{toDateForYear(item.birthday,'day')}}日
                    <i
                      v-if="item.departments"
                    >
                      <em>|</em>
                        <span class="depa_nowrap">
                            <Organization :name="item.departments" type="departmentName" :openid="item.departments[0]" :useOpenData="item.useOpenData" ></Organization>
                        </span>
                    </i>
                  </p>
                </div>
              </div>
              <div class="action">
                <p v-if="item.nextBirthdayDays <= 7">
                  {{toDays(item.nextBirthdayDays)}}
                  <i class="action-icon"></i>
                </p>
                <p class="birthday_last" v-if="item.nextBirthdayDays > 7">
                  生日已过
                  <i class="action-icon"></i>
                </p>
              </div>
            </li>
            <!--todo     -->
            <div class="list-loading" v-if="scrollListLoading">
              <p>加载中...</p>
            </div>
            <div class="bottom-over" v-show="isOver">
              <img src="../../assets/img/bottom-over.png" alt />
            </div>
          </ul>
        </div>
      </div>

      <!--</div>-->
      <!--没有人过生日时显示-->
      <div class="has-nobody" v-if="!total && isMember">
        <div class="heard">
          <p class="first">本周生日之星</p>
          <p class="second">0人过生日</p>
        </div>
        <div class="content">
          <div class="has-nobody-icon">
            <img src="../../assets/img/has-body-icon.png" alt />
          </div>
          <p>本周暂无生日的同事哟</p>
        </div>
      </div>

      <!--//  不在主机构-->
      <div class="has-nobody" v-if="!isMember">
        <div class="heard">
          <p class="first">本周生日之星</p>
          <p class="second">{{total}}人过生日</p>
        </div>
        <div class="content isMember">
          <div class="has-nobody-icon">
            <img src="../../assets/img/has-body-icon.png" alt />
          </div>
          <p class="isMember-text1">无法查看本周生日的同事</p>
          <p class="isMember-text2">请联系管理员</p>
        </div>
      </div>
    </div>
    <div class="coverBox" v-if="getBirthdayLoading"></div>
    <loading v-if="getBirthdayLoading"></loading>
    <div v-show="tipDialog" class="self-dialog-pop" ref="dialogWrap">
      <div class="self-dialog-content">
        <div class="content-wrap">
          <p>{{tipText}}</p>
        </div>
        <div class="btn-wraps">
          <a href="javascript:;" class="btn-txt" @click="hideMsg">知道啦</a>
        </div>
      </div>
    </div>
    <home :ishome="0"></home>
    <div class="overdue" v-if="overdue">
      <img src="../../assets/img/birthday/prompt.png" />
      <div class="tips1">生日数据已过期</div>
      <div class="tips2">即将为您转接最新生日数据</div>
      <a class="overdue-link" href="javascript:void(0)" @click="jumpNew">立即查看</a>
    </div>
  </Pull-to>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PullTo from "vue-pull-to";
import aghapi from "../../api/aghapi.js";
import Cookies from "js-cookie";
import loading from "../common/loading.vue";
import home from "../common/home.vue";
import Organization from "@/components/common/organization.vue";
export default {
  data() {
    return {
      loading: true,
      params: {
        page: 1,
        pageSize: 20,
        weekDate: null
      },
      weekList: "",
      total: "",
      totalPage: "",
      getBirthdayLoading: true,
      isMember: true,
      tipDialog: false,
      tipText: "",
      TOP_DEFAULT_CONFIG: {
        pullText: "", // 下拉时显示的文字
        triggerText: "", // 下拉到触发距离时显示的文字
        loadingText: "", // 加载中的文字
        doneText: "", // 加载完成的文字
        failText: "", // 加载失败的文字
        loadedStayTime: 0, // 加载完后停留的时间ms
        stayDistance: 50, // 触发刷新后停留的距离
        triggerDistance: 70 // 下拉刷新触发的距离
      },
      BOTTOM_DEFAULT_CONFIG: {
        pullText: "上拉加载",
        //            triggerText: '释放更新',
        loadingText: "加载中...",
        doneText: "",
        failText: "加载失败",
        loadedStayTime: 400,
        stayDistance: 50,
        triggerDistance: 5
      },
      bottomMethod: true,
      isOver: false,
      scrollListLoading: false,
      overdue: false,
    };
  },
  components: {
    PullTo,
    loading,
    home,
    Organization
  },
  computed: {
    ...mapGetters({
      userLoginFinish: "userLoginFinish",
      userInfo: "userInfo",
      weekParams: "weekParams",
      weekDataUserList: "weekDataUserList",
      weekCurPosY: "weekCurPosY",
      currentCorpId: "currentCorpId",
    }),
    queryCorpId() {
      return this.$route.query.corpId;
    },
    weekDate() {
      return this.$route.query.date;
    }
  },
  watch: {
    userLoginFinish: {
      handler: function(val, oldVal) {
        if (val) {
          this.initData();
        }
      },
      deep: true
    },
    //监听路由变化
    $route(to, from) {
      console.log(to, from);
      this.initData();
    }
  },
  created() {
    //用于检测用户是否登录
    // this.initData();
  
  },
  mounted() {
    //      window.addEventListener('scroll',this.menu)
    this.$nextTick(() => {
      if (this.weekCurPosY && this.weekCurPosY.value > 0) {
        this.getBirthdayLoading = true;
        setTimeout(() => {
          console.log("cur_pos_y", this.weekCurPosY);
          document
            .querySelector(".scroll-container")
            .scrollTo(0, this.weekCurPosY.value);
          this.$store.dispatch("setWeekCurPosY", { value: 0 });
          this.getBirthdayLoading = false;
        }, 600);
      } else {
        this.getBirthdayLoading = false;
      }
    });
    if (this.userLoginFinish) {
      this.initData();
    }
  },
  methods: {
    toDays(value) {
      if (value < 0) {
        return "生日已过";
      } else if (value === 0) {
        return "今天";
      } else if (value === 1) {
        return "明天";
      } else if (value === 2) {
        return "后天";
      } else {
        return value + "天";
      }
    },
    toDateForYear(value, type) {
      let arr = value.split("-");
      if (type === "month") {
        return arr[1];
      } else if (type === "day") {
        return arr[2];
      }
    },
    showMsg(txt) {
      this.tipText = txt;
      this.tipDialog = true;
      this.disableScroll();
      if (this.isIOS8()) {
        this.resetIos8DialogTop();
      }
    },
    hideMsg(event) {
      this.tipDialog = false;
    },
    disableScroll: function() {
      var dialogWrap = this.$refs.dialogWrap;
      dialogWrap.ontouchmove = function(e) {
        e.preventDefault();
      };
    },
    isIOS8() {
      var ua = window.navigator.userAgent.toLowerCase();
      return /iphone os ([8]+)_/.test(ua);
    },
    resetIos8DialogTop() {
      let scrollWrap = document.querySelector(".scroll-container");
      let widowA = window.screen.availHeight;
      var top = scrollWrap.scrollTop + widowA / 2 + 130;
      console.log("重置弹框top", scrollWrap.scrollTop, widowA, top);
      document.querySelector(".self-dialog-content").style.top = top + "px";
      // console.log("重置后的高度",dialogContent.style.top)
    },
    getWeekList(params) {
      let _this = this;
      aghapi.birthdayWeekList(params).then(res => {
        if (res.data && res.data.errno == 0) {
          _this.getBirthdayLoading = false;
          _this.weekList = res.data.body.list;
          _this.totalPage = res.data.body.totalPage;
          _this.overdue = res.data.body.overdue;
          _this.total = res.data.body.total;
          console.log(res);
          if (_this.weekList.length >= _this.total) {
            _this.bottomMethod = false;
          }
        } else if (res.data.errno == 1001001003) {
          _this.getBirthdayLoading = false;
          _this.isMember = false;
        }
      });
    },
    topLoadMore(loaded) {
      loaded("done");
    },
    loadMore(loaded) {
      console.log("board loadMore");
      let _this = this;
      _this.scrollListLoading = true;
      if (_this.params.page >= _this.totalPage) {
        _this.scrollListLoading = false;
        return;
      }
      _this.params.page += 1;
      this.$store.dispatch("setWeekParams", {
        page: _this.params.page,
        pageSize: _this.params.pageSize,
        weekDate: _this.weekDate,
        total: _this.total,
        totalPage: _this.totalPage
      });
      aghapi.birthdayWeekList(this.params).then(res => {
        if (res.data && res.data.errno == 0) {
          _this.weekList = _this.weekList.concat(res.data.body.list);
          this.$store.dispatch("setWeekDataUserList", _this.weekList);
          _this.scrollListLoading = false;
          if (_this.weekList.length == _this.total) {
            _this.scrollListLoading = false;
            _this.isOver = true;
          }
        }
      });
    },
    toPersonInfo(id) {
      let scrollTop = document.querySelector(".scroll-container").scrollTop;
      console.log("click fired", scrollTop);
      this.$store.dispatch("setWeekCurPosY", {
        value: scrollTop
      });
      this.$router.push({
        name: "birthdayPersonal",
        query: {
          subUid: id,
          corpId: this.currentCorpId
        }
      });
    },
    //获得本周的开始日期
    getWeekStartDate() {
      var date = new Date(); // 本周一的日期
      console.log("date1", date);
      date.setDate(date.getDate() - date.getDay() + 1);
      console.log("date2", date);
      var result =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " 00:00:00";

      console.log("result", result);
      // return this.formatDate(new Date(result));
      return new Date(result);
    },
    //获得本周的结束日期
    getWeekEndDate() {
      var date = new Date();
      // 本周日的日期
      date.setDate(date.getDate() - date.getDay() + 1);
      date.setDate(date.getDate() + 6);
      var result =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1) +
        "-" +
        date.getDate() +
        " 23:59:59";
      return new Date(result);
    },
    //格式化日期：yyyy-MM-dd
    formatDate(date) {
      var myyear = date.getFullYear();
      var mymonth = date.getMonth() + 1;
      var myweekday = date.getDate();
      if (mymonth < 10) {
        mymonth = "0" + mymonth;
      }
      if (myweekday < 10) {
        myweekday = "0" + myweekday;
      }
      return myyear + "-" + mymonth + "-" + myweekday;
    },
    jumpNew() {
      let url = "/m/#/birthday/board";
      window.location.href = url;
    },
    // 初始化数据
    initData() {
      //用于检测用户是否登录
      if (this.weekParams && !this.overdue) {
        let weekParams = $.extend(true, {}, this.weekParams);
        this.params.page = weekParams.page;
        this.params.pageSize = weekParams.pageSize;
        this.params.weekDate = weekParams.weekDate;
        this.totalPage = weekParams.totalPage;
        this.total = weekParams.total;
        let dataUserList = $.extend(true, [], this.weekDataUserList);
        this.weekList = dataUserList;
      } else {
        let params = {
          page: 1,
          pageSize: 20,
          weekDate: this.weekDate
        };
        if (this.userLoginFinish) {
          this.getWeekList(params);
        }
      }
    }
  }
};
</script>
<style lang="less" scoped>
.overdue {
  background-color: white;
  position: absolute;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  z-index: 999;
  left: 0;
  top: 0;
  text-align: center;
  img {
    margin: 3rem auto 1rem;
    width: 2.2rem;
    height: auto;
  }
  .tips1 {
    font-size: 0.55rem;
    margin-top: 0.5rem;
  }
  .tips2 {
    font-size: 0.4rem;
    margin-top: 0.3rem;
    color: #3c3c3c;
  }
  .overdue-link {
    display: block;
    width: 3.5rem;
    margin: 1rem auto 0;
    padding: 0.4rem 0.6rem;
    border: solid 1px #cccccc;
    color: #00b2ee;
    border-radius: 2px;
  }
}
</style>